import * as Sentry from '@sentry/react';

export const initSentry = () => {
  if (process.env.REACT_APP_ENV === 'production' && process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_ENV,
      sendDefaultPii: true,
      integrations: [],
    });
  }
};

export const captureApolloError = (error: any, operationName?: string, variables?: any) => {
  Sentry.captureException(error, {
    extra: {
      operationName,
      variables,
    },
  });
};
